import React, { FC, useRef, useState } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { IonModal, IonHeader, IonContent, createAnimation } from '@ionic/react'
import { menuMobx, cartMobx } from 'restaurant'
import { Input } from '@cps'
import hotProductMobx from 'mobx/menu/hotProduct.mobx'
import ListProductItem from '../../components/ProductItem/ListProductItem'
import './index.scss'

// interface
interface IProps {
  resolve?: any;
  reject?: any;
  isSearch?: boolean;
}

const CategoryModal: FC<IProps> = ({ resolve, reject, isSearch }) => {
  const modalRef = useRef<any>()
  const searchInputRef = useRef<any>()
  const { categories, selectCategory } = menuMobx
  const { categoryNoToCntMap, productNoToCntMap } = cartMobx.cartResult
  const enterAnimation = (baseEl: any) => {
    const backdropAnimation = createAnimation()
      .addElement(baseEl.querySelector('ion-backdrop'))
      .fromTo('opacity', '0.01', 'var(--backdrop-opacity)')
    const wrapperAnimation = createAnimation()
      .addElement(baseEl.querySelector('.modal-wrapper'))
      .duration(150)
      .keyframes([
        { offset: 0, opacity: '0', transform: 'translateX(50%)' },
        { offset: 1, opacity: '1', transform: 'translateX(0)' },
      ])
    return createAnimation()
      .addElement(baseEl)
      .easing('ease-out')
      .duration(150)
      .addAnimation([backdropAnimation, wrapperAnimation])
  }
  const leaveAnimation = (baseEl: any) => {
    return enterAnimation(baseEl).direction('reverse')
  }
  const handleSelectCategory = function (no: string) {
    selectCategory(no)
    resolve(no)
  }

  const [showCategory, setShowCategory] = useState(!!menuMobx.selectCategoryNo)
  return (
    <IonModal
      cssClass={`category-modal ${isSearch ? 'search-category-modal' : ''}`}
      isOpen
      enterAnimation={enterAnimation}
      leaveAnimation={leaveAnimation}
      onWillPresent={() => {
        if (isSearch) {
          hotProductMobx.init()
          modalRef.current.classList.add('fullwidth')
          menuMobx.setSearchKey('')
        }
      }}
      onDidPresent={() => {
        if (!isSearch && menuMobx.searchKey !== null) {
          menuMobx.setSearchKey(null)
        }
      }}
      ref={modalRef}
    >
      <IonHeader>
        <input style={{ display: 'none' }} />
        <div className='title'>
          <div className='search-wrap'>
            <Input
              id='categoryModalSearchInput'
              icon='iconfont icon-search'
              value={menuMobx.searchKey || ''}
              placeholder={i18n.t('menu.search_product')}
              onChange={(e) => {
                menuMobx.setSearchKey(e.target.value)
              }}
              autoFocus
              ref={searchInputRef}
              onFocus={(e) => {
                hotProductMobx.init()
                modalRef.current.classList.add('fullwidth')
                menuMobx.setSearchKey('')
              }}
            />
            {
              menuMobx.searchKey !== null ? (
                <span onClick={() => {
                  menuMobx.setSearchKey(null)
                  reject()
                }}
                >
                  {i18n.t('common.cancel')}
                </span>
              ) : null
            }
          </div>
        </div>
      </IonHeader>
      <IonContent>
        {
          menuMobx.searchKey === null && (
            <div className={`serach-by-category ${showCategory ? 'transform' : ''}`} onClick={() => setShowCategory(!showCategory)}>
              <span>{i18n.t('menu.searchByCategory')}</span>
              <i className='iconfont icon-caret--down' />
            </div>
          )
        }
        <div className='container'>
          {
            menuMobx.searchKey !== null ? (
              <div className='search-result'>
                {
                  menuMobx.searchKey === '' && !!hotProductMobx.HotViewProduct.length && (
                    <h5>{i18n.t('menu.hot_product')}</h5>
                  )
                }
                {
                  menuMobx.searchKey === '' && hotProductMobx.HotViewProduct.map((product) => {
                    return (
                      <div
                        className='simple-product' onClick={() => {
                          resolve(product)
                        }} key={product.no}
                      >{product.name}
                      </div>
                    )
                  })
                }
                {
                  menuMobx.searchKey !== '' && menuMobx.searchedProducts.map(product => {
                    const count = productNoToCntMap?.[product.no] || 0
                    return (<ListProductItem onClick={() => resolve(product)} key={product.no} type='list' product={product} count={count} lazy={false} />)
                  })
                }
              </div>
            ) : showCategory ? (
              <div className='category-list'>
                <div
                  key='all-category'
                  className='item'
                  onClick={() => handleSelectCategory('')}
                >
                  <span>{i18n.t('menu.allCategories')}</span>
                </div>
                {
                  categories.map(category => {
                    return (
                      <div
                        key={category.no}
                        onClick={() => handleSelectCategory(category.no)}
                        className={`item${category.no === menuMobx.selectCategoryNo ? ' selected' : ''}`}
                      >
                        <span>{category.name}</span>
                        {
                          categoryNoToCntMap[category.no] &&
                          (
                            <span className='cnt'>
                              {categoryNoToCntMap[category.no]}
                            </span>
                          )
                        }
                      </div>
                    )
                  })
                }
              </div>
            ) : null
          }
        </div>
      </IonContent>
    </IonModal>
  )
}

export default observer(CategoryModal)
